import { ButtonColor } from "./types";
import { GlyphIcon } from "../icons";
import * as React from "react";
import { ImageButton } from "./ImageButton";
import { GlyphButton } from "./GlyphButton";
import { ButtonProps } from "react-bootstrap";

export interface IconButtonProps extends ButtonProps {
    imagePath?: string;
    glyph?: GlyphIcon;
    color?: ButtonColor;
}

export const IconButton = (props: IconButtonProps) => {
    const { glyph, imagePath, className, ...rest } = props;
    if (imagePath) {
        return <ImageButton imagePath={imagePath} className={className} {...rest} />;
    }
    if (glyph) {
        return <GlyphButton color={ButtonColor.PRIMARY} className={className} {...rest} glyph={glyph} />;
    }

    return <GlyphButton color={ButtonColor.DANGER} className={className} {...rest} glyph={GlyphIcon.ALERT} />;
};
